import type { ISSOConfig } from '~/types/sso.config.types'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { SSO_DESTINATION } from '~/types/sso.config.types'

export const useSSOConfigsStore = defineStore('ssoConfigs', () => {
  // #region state
  const ssoConfig = useStorage('ssoConfig', {} as ISSOConfig)
  // #endregion

  // #region actions
  const loadSsoConfigs = async (memberId: string) => {
    const ssoConfigs = await platformApi.getSSOConfig(memberId, { ssoDestination: SSO_DESTINATION.TRAVELER_CASHBACK })
    if (ssoConfigs && ssoConfigs.length > 0)
      ssoConfig.value = ssoConfigs.at(0)
  }
  // #endregion

  return {
    ssoConfig,
    loadSsoConfigs,
  }
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useSSOConfigsStore as any, import.meta.hot))
